import { render, staticRenderFns } from "./TestPassResult.vue?vue&type=template&id=9f00f3c2&scoped=true&"
import script from "./TestPassResult.vue?vue&type=script&lang=ts&"
export * from "./TestPassResult.vue?vue&type=script&lang=ts&"
import style0 from "./TestPassResult.vue?vue&type=style&index=0&id=9f00f3c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f00f3c2",
  null
  
)

export default component.exports